/* ==========================================================================
   INTC Vape LP — buy block behaviour (Slice 5, revised 2026-09-04)
   Adapted from Komuso-Vape-LP-Handoff/shopify/page.komuso-vape-lp.liquid
   lines 846–959, with plan changes:

   D3 — product data is NOT hardcoded here. It is read from the JSON blob
        <script type="application/json" id="intc-vlp-models"> that the section
        renders from the live product objects. Prices arrive in CENTS (or null
        when the product could not be resolved) and are formatted here.

   D4 (REVISED) — this file no longer intercepts add-to-cart clicks AT ALL.
        Measured on the store preview: the storefront stack (Rebuy SmartCart /
        Vitals, loaded on every page) already intercepts a[href*="/cart/add"]
        clicks, preventDefaults, POSTs /cart/add.js and opens the cart drawer.
        Our own fetch-enhancement fired IN ADDITION to it → every click added
        the item TWICE. The plain relative /cart/add?id=…&quantity=1 links stay
        in the markup as the no-JS fallback; this file only keeps their ids in
        sync with the selected finish.

   STICKY BAR (restored 2026-09-04) — the bar the user sees on product pages
        is Broadcast's OWN #cart-bar inside sections/product.liquid: it needs
        a product object + the theme's product-section JS and cannot run on a
        page template (and on multi-variant products its button only scrolls).
        So the LP keeps its own bar, styled after the theme's. Its button is a
        plain /cart/add link — the store stack intercepts it (see D4 above);
        this file only toggles visibility (rAF-throttled #intc-hero tracking —
        SPEC §4 forbids replacing this with an IntersectionObserver
        rootMargin) and keeps the label/price/href on the selected finish.

   Everything lives in this IIFE — no globals. All ids are intc- prefixed.
   ========================================================================== */
(function () {
  'use strict';

  /* Cents → dollars. Whole-dollar prices print without decimals ($79),
     anything else keeps two ($79.50). Null/undefined prints nothing. */
  function fmt(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    return '$' + (cents % 100 === 0 ? (cents / 100) : (cents / 100).toFixed(2));
  }

  /* Darken a hex by a fraction, for the button's hover state (handoff 868–874).
     Non-hex values (e.g. a gradient dot leaking in) are returned untouched. */
  function shade(hex, amount) {
    if (!/^#[0-9A-Fa-f]{6}$/.test(hex)) return hex;
    var n = parseInt(hex.slice(1), 16);
    var r = Math.round(((n >> 16) & 255) * (1 - amount));
    var g = Math.round(((n >> 8) & 255) * (1 - amount));
    var b = Math.round((n & 255) * (1 - amount));
    return 'rgb(' + r + ',' + g + ',' + b + ')';
  }

  /* ---------- finish selector / per-product memory (handoff 877–947) ------ */
  function initBuy() {
    var dataEl     = document.getElementById('intc-vlp-models'),
        picks      = document.getElementById('intc-picks'),
        chiprow    = document.getElementById('intc-chiprow'),
        chiplabel  = document.getElementById('intc-chiplabel'),
        addbtn     = document.getElementById('intc-addbtn'),
        addprice   = document.getElementById('intc-addprice'),
        sticktitle = document.getElementById('intc-sticktitle'),
        stickprice = document.getElementById('intc-stickprice'),
        stickbtn   = document.getElementById('intc-stickbtn'),
        swatchName = document.getElementById('intc-swatchName'),
        swatchUp   = document.getElementById('intc-swatchUp');

    if (!dataEl || !picks || !chiprow || !addbtn) return;

    var MODELS;
    try {
      MODELS = JSON.parse(dataEl.textContent).products;
    } catch (e) {
      return; // malformed blob: the plain-link markup keeps working untouched
    }
    if (!MODELS || !MODELS.length) return;

    /* One remembered finish per product, so switching back keeps your choice. */
    var state = { model: 0, vi: MODELS.map(function () { return 0; }) };
    var checked = picks.querySelector('input[name="model"]:checked');
    if (checked) state.model = parseInt(checked.value, 10) || 0;

    function base(mi) {
      var prices = MODELS[mi].variants
        .map(function (v) { return v.price; })
        .filter(function (p) { return typeof p === 'number'; });
      return prices.length ? Math.min.apply(null, prices) : null;
    }

    /* Paint the buy button in the selected finish. White text holds up on
       every one of these, which is how the theme sets its secondary button. */
    function paintButton(v) {
      if (!v.btn) return;
      addbtn.style.setProperty('--btn-bg', v.btn);
      addbtn.style.setProperty('--btn-bg-hover', shade(v.btn, 0.12));
      addbtn.style.setProperty('--btn-ink', '#FFFFFF');
    }

    /* Swap a card's shot, with a short fade so the change is noticed. */
    function setCardImage(mi) {
      var el = document.getElementById('intc-img-' + mi),
          v  = MODELS[mi].variants[state.vi[mi]];
      if (!el || !v || !v.img || el.getAttribute('src') === v.img) return;
      el.style.opacity = '0';
      el.src = v.img;
      el.alt = MODELS[mi].name + ' in ' + v.t;
      requestAnimationFrame(function () { el.style.opacity = '1'; });
    }

    function render() {
      var m = MODELS[state.model];
      if (!m || !m.variants.length) return;
      if (state.vi[state.model] >= m.variants.length) state.vi[state.model] = 0;
      var vi = state.vi[state.model],
          v  = m.variants[vi],
          b  = base(state.model);

      if (chiplabel) chiplabel.textContent = m.label;
      if (swatchName) swatchName.textContent = v.t;
      if (swatchUp) {
        swatchUp.textContent =
          (typeof v.price === 'number' && typeof b === 'number' && v.price > b)
            ? '+' + fmt(v.price - b) : '';
      }

      chiprow.textContent = '';
      m.variants.forEach(function (o, i) {
        var up = (typeof o.price === 'number' && typeof b === 'number' && o.price > b)
          ? ', +' + fmt(o.price - b) : '';
        var l = document.createElement('label');
        l.className = 'sw';
        l.title = o.t + up;
        l.innerHTML = '<input type="radio" name="intc-finish"' + (i === vi ? ' checked' : '') +
                      ' aria-label="' + o.t + (typeof o.price === 'number' ? ', ' + fmt(o.price) : '') + '">' +
                      '<i style="background:' + o.dot + '"></i>';
        l.querySelector('input').addEventListener('change', function () {
          state.vi[state.model] = i;
          render();
        });
        chiprow.appendChild(l);
      });

      paintButton(v);
      /* The store stack (Rebuy/Vitals) reads these hrefs on click and does
         the AJAX add + drawer itself — we only keep the variant id current. */
      var href = '/cart/add?id=' + v.id + '&quantity=1';
      addbtn.href = href;
      if (stickbtn) stickbtn.href = href;
      if (addprice) addprice.textContent = fmt(v.price);
      if (sticktitle) sticktitle.textContent = m.name + ' · ' + v.t;
      if (stickprice) stickprice.textContent = fmt(v.price);

      /* "from $79" on products whose finishes differ in price (the Classic). */
      var priceEls = picks.querySelectorAll('.pick .pprice');
      MODELS.forEach(function (mm, i) {
        var bb = base(i);
        if (priceEls[i] && typeof bb === 'number') {
          priceEls[i].textContent = (mm.from ? 'from ' : '') + fmt(bb);
        }
        setCardImage(i);
      });
    }

    picks.querySelectorAll('input[name="model"]').forEach(function (r) {
      r.addEventListener('change', function () {
        state.model = parseInt(r.value, 10) || 0;
        render();
      });
    });

    render();
  }

  /* ---------- sticky buy bar (handoff 949–959) ----------------------------
     Tracks the hero's bottom edge, rAF-throttled. Do NOT replace with an
     IntersectionObserver rootMargin — SPEC §4 forbids it. */
  function initStick() {
    var stick = document.getElementById('intc-stick'),
        hero  = document.getElementById('intc-hero');
    if (!stick || !hero) return;
    var queued = false;
    function syncStick() {
      queued = false;
      stick.classList.toggle('on', hero.getBoundingClientRect().bottom < 64);
    }
    window.addEventListener('scroll', function () {
      if (!queued) { queued = true; requestAnimationFrame(syncStick); }
    }, { passive: true });
    window.addEventListener('resize', syncStick);
    syncStick();
  }

  function boot() {
    try { initBuy(); } catch (e) { /* plain markup keeps working */ }
    try { initStick(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
